import { EventEmitter } from '@angular/core';
import { SvgIcon } from '@services/svg-icon.service';

export type ButtonSquareState = 'unselected' | 'selected';
export type ButtonSquareSize = 'medium' | 'large';

export interface ButtonSquareProps {
  state?: ButtonSquareState;
  size?: ButtonSquareSize;
  icon?: SvgIcon;
  iconUrl?: string;
  title: string;
  comingSoon?: boolean;
  propNew?: boolean;
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
}

export interface ButtonSquareEvents {
  clicked: EventEmitter<{
    state: ButtonSquareState;
    title: string;
    icon?: SvgIcon;
    iconUrl?: string;
  }>;
  stateChanged: EventEmitter<ButtonSquareState>;
}

export interface ButtonSquareStyleConfig {
  container: string;
  iconWrapper: string;
  icon: string;
  title: string;
  comingSoonBadge?: string;
  newBadge?: string;
}

export interface ComputedButtonSquareClasses {
  container: string;
  iconWrapper: string;
  icon: string;
  title: string;
  comingSoonBadge: string;
  newBadge: string;
}

export const defaultButtonSquareProps: Required<Omit<ButtonSquareProps, 'icon' | 'iconUrl' | 'title' | 'className' | 'ariaLabel'>> = {
  state: 'unselected',
  size: 'medium',
  comingSoon: false,
  propNew: false,
  disabled: false,
};

export const isButtonSquareState = (value: any): value is ButtonSquareState => {
  return typeof value === 'string' && ['unselected', 'selected'].includes(value);
};

export const isButtonSquareSize = (value: any): value is ButtonSquareSize => {
  return typeof value === 'string' && ['medium', 'large'].includes(value);
};

export interface ButtonSquareContent {
  hasIcon: boolean;
  hasTitle: boolean;
  hasComingSoonBadge: boolean;
  hasNewBadge: boolean;
}